import { useNavigate } from 'react-router-dom';
import { Card, Button, PageHeader } from '../components/ui';
import { useAuth } from '../lib/auth';

export function SettingsPage() {
  const navigate = useNavigate();
  const { user, tenant, logout } = useAuth();

  async function handleLogout() {
    await logout();
    navigate('/auth/login');
  }

  return (
    <div>
      <PageHeader title="Settings" />

      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)', maxWidth: 640 }}>
        <Card>
          <h3 style={sectionTitle}>Workspace</h3>
          <Row label="Name" value={tenant?.name ?? '—'} />
          <Row label="Slug" value={tenant?.slug ?? '—'} />
          <Row label="Plan" value={tenant?.plan ?? '—'} />
          <Row label="Status" value={tenant?.status ?? '—'} />
        </Card>

        <Card>
          <h3 style={sectionTitle}>Account</h3>
          <Row label="Email" value={user?.email ?? '—'} />
          <Row label="Role permissions" value={`${user?.permissions.length ?? 0} granted`} />
        </Card>

        <Card>
          <h3 style={sectionTitle}>Available features</h3>
          <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-secondary)', margin: '0 0 var(--space-2)' }}>
            Every feature is API-first and ready. UI for each rolls out as we build them.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 'var(--space-2)', marginTop: 'var(--space-3)' }}>
            {features.map((f) => (
              <div key={f.name} style={{ padding: 'var(--space-2) var(--space-3)', background: 'var(--color-surface-secondary)', borderRadius: 'var(--radius-md)', fontSize: 'var(--text-sm)' }}>
                {f.name}
              </div>
            ))}
          </div>
        </Card>

        <Card>
          <h3 style={sectionTitle}>Sign out</h3>
          <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-secondary)', margin: '0 0 var(--space-3)' }}>
            End your session on this device.
          </p>
          <Button variant="danger" onClick={handleLogout}>Sign out</Button>
        </Card>
      </div>
    </div>
  );
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', padding: 'var(--space-2) 0', borderBottom: '1px solid var(--color-border-primary)', fontSize: 'var(--text-sm)' }}>
      <span style={{ color: 'var(--color-text-secondary)' }}>{label}</span>
      <span style={{ color: 'var(--color-text-primary)', fontWeight: 500 }}>{value}</span>
    </div>
  );
}

const sectionTitle: React.CSSProperties = {
  margin: '0 0 var(--space-3)',
  fontSize: 'var(--text-base)',
  fontWeight: 600,
  color: 'var(--color-text-primary)',
};

const features = [
  { name: 'CRM' },
  { name: 'Booking' },
  { name: 'Invoicing' },
  { name: 'Messaging' },
  { name: 'Client portal' },
  { name: 'Marketing' },
  { name: 'Pipelines' },
  { name: 'Workflows' },
  { name: 'Tasks' },
  { name: 'Reporting' },
  { name: 'Pages & funnels' },
  { name: 'Courses' },
  { name: 'eSignature' },
  { name: 'Community' },
  { name: 'Voice & IVR' },
  { name: 'Social planner' },
  { name: 'Reputation' },
  { name: 'White-label' },
];
